import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-secondary-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-4">
          准备好打造你的蜜桃臀了吗？
        </h2>
        <p className="text-foreground-600 text-sm mb-8 max-w-xl mx-auto">
          从今天开始，跟着专业方案科学训练，让每一次训练都有实质成效。
          选择适合你的训练方向，迈出第一步吧！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/training-moves"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap text-sm"
          >
            立即开始训练
            <i className="ri-rocket-line"></i>
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-background-50 text-foreground-800 font-medium rounded-lg border border-background-200/60 hover:border-primary-200 hover:text-primary-600 transition-colors whitespace-nowrap text-sm"
          >
            了解更多
            <i className="ri-information-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}